import { BridgeTransactionHistory } from "@mezo/api"
import { createSlice } from "@reduxjs/toolkit"

export type BridgeTransaction = {
  history: BridgeTransactionHistory[]
  latestTransactions: BridgeTransactionHistory[]
  hasLoadedBridgeData: boolean
}

const initialState: BridgeTransaction = {
  history: [],
  latestTransactions: [],
  hasLoadedBridgeData: false,
}

export const bridgeSlice = createSlice({
  name: "bridge",
  initialState,
  reducers: {
    setBridgeHistory: (
      immerState,
      { payload }: { payload: BridgeTransactionHistory[] },
    ) => {
      immerState.history = payload
    },
    setLatestBridgeTransaction: (
      immerState,
      { payload }: { payload: BridgeTransactionHistory },
    ) => {
      immerState.latestTransactions = immerState.latestTransactions
        ? [...immerState.latestTransactions, payload]
        : [payload]
    },
    setHasLoadedBridgeData: (immerState, { payload }: { payload: boolean }) => {
      immerState.hasLoadedBridgeData = payload
    },
    resetBridge: () => initialState,
  },
})

export const {
  setBridgeHistory,
  setHasLoadedBridgeData,
  setLatestBridgeTransaction,
  resetBridge,
} = bridgeSlice.actions

export default bridgeSlice.reducer
